import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchFuelPriceList,
  type FuelPriceListDoc,
} from '../repositories/fuelPrices.js';

/**
 * F-02: `fuel_price_list/{tenantId}` の React Query hook。
 *
 * cache key: `['fuelPriceList', tenantId]`
 */
export function useFuelPriceList(
  tenantId: string | null | undefined,
): UseQueryResult<FuelPriceListDoc | null, Error> {
  return useQuery({
    queryKey: ['fuelPriceList', tenantId],
    queryFn: () => fetchFuelPriceList(tenantId as string),
    enabled: !!tenantId,
    staleTime: 30 * 1000,
  });
}
